"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineSpine = void 0;
/// <reference types="pixi-spine" />
const gsap_1 = require("gsap");
class TimelineSpine extends PIXI.spine.Spine {
    constructor(spineData) {
        super(spineData);
        this.now = 0;
        this.last = 0;
        this.autoUpdate = false;
        this.toSetupPose();
    }
    toSetupPose() {
        this.skeleton.setToSetupPose();
        this.update(0);
    }
    setMix(fromName, toName, duration) {
        this.stateData.setMix(fromName, toName, duration);
    }
    onStart() {
        this.now = 0;
        this.last = 0;
    }
    onUpdate() {
        let delta = Math.abs(this.now - this.last);
        this.update(delta);
        this.last = this.now;
    }
    getAnimation(animationName, animationDelay = 0, ease = gsap_1.Linear.easeNone) {
        const tl = new gsap_1.TimelineLite({
            onStart: () => this.onStart(),
            onUpdate: () => this.onUpdate()
        });
        const names = (typeof animationName === "string") ? [animationName] : animationName;
        let delay = [];
        if (typeof animationDelay === "number") {
            for (let i = 0; i < names.length; i++) {
                delay.push(animationDelay);
            }
        }
        let lengthDiff = names.length - delay.length;
        for (let i = 0; i < lengthDiff; i++) {
            delay.push(0);
            console.warn("TimelineSpine, animationDelay.length and animationName.length don't match. animationDelay are padded with 0 duration delays.");
        }
        let longestDuration = 0;
        for (let i = 0; i < names.length; i++) {
            const animation = this.spineData.findAnimation(names[i]);
            longestDuration = animation.duration > longestDuration ? animation.duration : longestDuration;
            tl.add(() => this.state.setAnimationWith(i, animation, false), delay[i]);
        }
        longestDuration += delay[0];
        tl.add(new gsap_1.TweenLite(this, longestDuration, { now: longestDuration, ease: ease }), 0);
        return tl;
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
    }
}
exports.TimelineSpine = TimelineSpine;
//# sourceMappingURL=TimelineSpine.js.map